import { render } from "./verifypremium.vue?vue&type=template&id=27d9bee0"
import script from "./verifypremium.vue?vue&type=script&lang=js"
export * from "./verifypremium.vue?vue&type=script&lang=js"

import "./verifypremium.vue?vue&type=style&index=0&id=27d9bee0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__